export default function (state) {
    state.items = [];
}